import EntityModel from '@/common/models/entity-model';

export default class InvoiceTimeShiftModel extends EntityModel {
    static InvoiceTimeShiftChronologies = {
        before: 'before',
        after: 'after',
    };

    static Units = {
        day: 'day',
        days: 'days',
        hour: 'hour',
        hours: 'hours',
        minute: 'minute',
        minutes: 'minutes',
        month: 'month',
        months: 'months',
        second: 'second',
        seconds: 'seconds',
        year: 'year',
        years: 'years',
    };

    static getUnitsList() {
        return Object
            .values(InvoiceTimeShiftModel.Units)
            .filter(value => value[value.length - 1] !== 's');
    }

    /**
     *
     * @param {object} issueTimeShift
     * @param {object} dueTimeShift
     */
    hydrate({
        issueTimeShift = null,
        dueTimeShift = null,
    } = {}) {
        this.issueTimeShift = issueTimeShift;
        this.dueTimeShift = dueTimeShift;
    }

    disableIssueTimeShift() {
        this.issueTimeShift = null;
    }

    enableIssueTimeShift() {
        this.issueTimeShift = {
            chronology: InvoiceTimeShiftModel.InvoiceTimeShiftChronologies.before,
        };
    }

    disableDueTimeShift() {
        this.dueTimeShift = null;
    }

    enableDueTimeShift() {
        this.dueTimeShift = {
            duration: 1,
            unit: InvoiceTimeShiftModel.Units.hour,
        };
    }

    getPayload() {
        if (!this.issueTimeShift && !this.dueTimeShift) {
            return null;
        }
        return {
            issueTimeShift: this.issueTimeShift,
            dueTimeShift: this.dueTimeShift,
        };
    }
}
